import React from "react";
import { Link } from "react-router-dom";

export default function ServiceDirectory() {
  return (
    <section className="container sec-svc-list svc-dir-section">
      <div className="center mb-44">
        <div className="eyebrow">All services </div>
        <h2 className="h-lg">Explore every service we offer</h2>
        <p className="lead-sm">
          From custom software and CMS to e-commerce, marketing and managed IT —
          pick a service to see how we approach it.
        </p>
      </div>
      <div className="svc-list svc-cat-grid">
        <div className="svc-list-item card svc-cat">
          <div className="ico">
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.9"
              viewBox="0 0 24 24"
            >
              <polyline points="16 18 22 12 16 6"></polyline>
              <polyline points="8 6 2 12 8 18"></polyline>
            </svg>
          </div>
          <div className="svc-cat-body">
            <h3>Web Development</h3>

            <ul className="svc-sub">
              <li>
                <Link to="/nodejs">Node.js</Link>
              </li>
              <li>
                <Link to="/angularjs">Angular</Link>
              </li>
              <li>
                <Link to="/cakephp">CakePHP</Link>
              </li>
              <li>
                <Link to="/custom-php-software-solutions">Custom PHP</Link>
              </li>
              <li>
                <Link to="/react-js-development">React JS</Link>
              </li>
              <li>
                <Link to="/website-design-&-development">
                  Website Design & Development
                </Link>
              </li>
              <li>
                <Link to="/react-native">React Native (Mobile Apps)</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="svc-list-item card svc-cat">
          <div className="ico">
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.9"
              viewBox="0 0 24 24"
            >
              <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
              <polyline points="2 17 12 22 22 17"></polyline>
              <polyline points="2 12 12 17 22 12"></polyline>
            </svg>
          </div>
          <div className="svc-cat-body">
            <h3>CMS & Migration</h3>

            <ul className="svc-sub">
              <li>
                <Link to="/wordpress-development">WordPress</Link>
              </li>
              <li>
                <Link to="/drupal">Drupal</Link>
              </li>
              <li>
                <Link to="/custom-cms">Custom CMS</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="svc-list-item card svc-cat">
          <div className="ico">
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.9"
              viewBox="0 0 24 24"
            >
              <path d="m3 11 18-5v12L3 14v-3z"></path>
              <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"></path>
            </svg>
          </div>
          <div className="svc-cat-body">
            <h3>Digital Marketing</h3>

            <ul className="svc-sub">
              <li>
                <Link to="/seo">SEO</Link>
              </li>
              <li>
                <Link to="/social-media">Social Media</Link>
              </li>
              <li>
                <Link to="/digital-marketing-services">Digital Marketing</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="svc-list-item card svc-cat">
          <div className="ico">
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.9"
              viewBox="0 0 24 24"
            >
              <circle cx="8" cy="21" r="1"></circle>
              <circle cx="19" cy="21" r="1"></circle>
              <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
            </svg>
          </div>
          <div className="svc-cat-body">
            <h3>E-Commerce</h3>

            <ul className="svc-sub">
              <li>
                <Link to="/magento">Magento</Link>
              </li>
              <li>
                <Link to="/woocommerce-development">WooCommerce</Link>
              </li>
              <li>
                <Link to="/shopify">Shopify</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="svc-list-item card svc-cat svc-cat--wide">
          <div className="ico">
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.9"
              viewBox="0 0 24 24"
            >
              <rect height="8" rx="2" width="20" x="2" y="2"></rect>
              <rect height="8" rx="2" width="20" x="2" y="14"></rect>
              <line x1="6" x2="6.01" y1="6" y2="6"></line>
              <line x1="6" x2="6.01" y1="18" y2="18"></line>
            </svg>
          </div>
          <div className="svc-cat-body">
            <h3>Server & Networking</h3>

            <ul className="svc-sub">
              <li>
                <Link to="/server-and-networking-administration">
                  Server & Networking Admin
                </Link>
              </li>
              <li>
                <Link to="/noc-services">Managed NOC Services</Link>
              </li>
              <li>
                <Link to="/vsa-services">VSA Services</Link>
              </li>
              <li>
                <Link to="/on-demand-it-support-services">
                  On-Demand IT Support
                </Link>
              </li>
              <li>
                <Link to="/managed-cloud-migration-services">
                  Managed Cloud & Migration
                </Link>
              </li>
              <li>
                <Link to="/virtualization-solutions">
                  Virtualization Solutions
                </Link>
              </li>
              <li>
                <Link to="/after-hours-noc-support">
                  After-Hours NOC Support
                </Link>
              </li>
              <li>
                <Link to="/network-monitoring-outsourcing-services">
                  Network Monitoring
                </Link>
              </li>
              <li>
                <Link to="/managed-it-services">Managed IT Services</Link>
              </li>
              <li>
                <Link to="/expertise">Server & Network Expertise</Link>
              </li>
              <li>
                <Link to="/website-monitoring-and-maintenance">
                  Website Monitoring & Maintenance
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
